<template>
  <div>
    <div class="qrWrap">
      <p class="title">欢迎来到{{ APP_WINNY_NAME }}</p>
      <vue-qr class="qrStyle" :text="url" style="display: block;" :margin="0" />
      <div class="bottomContent">
        <p class="text1">请使用手机扫码去签约</p>
        <p class="tip" v-if="APP_WINNY_NAME == '神农购销' || APP_WINNY_NAME == '景瓷兴'">签约时间<span>交易日 8:50-21:00</span></p>
        <p class="tip" v-else>签约时间<span>周一到周五9：00-20：30，周六9：00-16：00</span></p>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol */
import VueQr from 'vue-qr'
export default {
  name: 'NoOpen',
  components: {
    VueQr
  },
  data() {
    return {
      tel: localStorage.getItem('myPhone'),
      baseUrl: window.g.APP_PATH_mobile,
      fundUrl: localStorage.getItem('qrContent'),
      url: '',
      APP_WINNY_NAME: window.g.APP_WINNY_NAME
    }
  },
  mounted() {
    // if (window.g.Bank_Id === 39) {
    //   this.getSessionKey()
    // } else {
    this.getOrgOrPerson()
    // }
  },
  methods: {
    // 得到秘钥 --- 个人签约
    getSessionKey() {
      http
        .getRes(protocol.param_getSessionKey4)
        .then(response => {
          var { code, message, value } = response.data
          if (Number(code) === 0) {
            this.url = `${this.baseUrl}key=${value}&tel=${this.tel}`
          } else {
            this.$message(message)
          }
        })
        .catch(() => {
          // setTimeout(() => {
          //   this.queryQuantity()
          // }, 1000)
        })
    },
    // 得到秘钥 --- 企业签约
    getSessionKey1() {
      http
        .getRes(protocol.param_getSessionKey5)
        .then(response => {
          var { code, message, value } = response.data
          if (Number(code) === 0) {
            this.url = `${this.baseUrl}key=${value}&tel=${this.tel}`
          } else {
            this.$message(message)
          }
        })
        .catch(() => {
          // setTimeout(() => {
          //   this.queryQuantity()
          // }, 1000)
        })
    },
    // 判断是个人/企业开户
    getOrgOrPerson() {
      http.postFront(protocol.param_getOrgOrPerson).then(response => {
        var { code, value, message } = response.data
        if (Number(code) === 0) {
          // 开户类型： 1-个人开户 2-企业开户 0-未开户
          if (value.type === 1) {
            this.getSessionKey()
            // this.url = `${this.baseUrl}${this.fundUrl}&torouterpath=signUpTo`
          } else if (value.type === 2) {
            this.getSessionKey1()
            // this.url = `${this.baseUrl}${this.fundUrl}&torouterpath=signUpToEn`
          }
        } else {
          this.$message(message)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.qrWrap {
  width: 1006px;
  background-color: #f1f1f1;
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 80px;
  .title {
    font-family: Source Han Sans SC;
    font-weight: bold;
    font-size: 24px;
    color: #333333;
    padding-top: 109px;
    padding-bottom: 49px;
    text-align: center;
  }
  .qrStyle {
    width: 270px;
    height: 270px;
    margin: 0 auto;
  }
  .text1 {
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    text-align: center;
    margin-top: 38px;
  }
  .tip {
    text-align: center;
    padding: 20px 0 160px 0;
    font-family: Source Han Sans SC;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    span {
      padding-left: 10px;
      color: #B10101
    }
  }
}
</style>
